import React from 'react';
import { Card, CardHeader, CardBody } from '../ui/Card';
import { ClipboardCheckIcon, HeadphonesIcon, TrendingUpIcon, MapPinIcon } from 'lucide-react';
export function WhyDestaMeet() {
  const reasons = [{
    icon: <ClipboardCheckIcon className="h-8 w-8 text-[#0099A1]" data-id="element-294" />,
    title: 'End-to-End Logistics',
    description: 'From transportation arrangements to room blocks to event planning - we handle every detail.'
  }, {
    icon: <HeadphonesIcon className="h-8 w-8 text-[#0099A1]" data-id="element-295" />,
    title: 'Full Service Solutions Only',
    description: 'Travel Agency. Planning. Design. Production. Technology. Concierge. DestaMeet elevates your brand from all angles on your event. No need to source any team members externally.'
  }, {
    icon: <TrendingUpIcon className="h-8 w-8 text-[#0099A1]" data-id="element-296" />,
    title: 'Premium Value',
    description: 'We curate exceptional experiences that deliver measurable ROI through increased employee engagement, retention & productivity'
  }, {
    icon: <MapPinIcon className="h-8 w-8 text-[#0099A1]" data-id="element-297" />,
    title: 'Location Expertise',
    description: 'Work with a dedicated team that has hosted 1000+ events in the Cancun/Riviera Maya over the past decade. Our On-site team provides bilingual support in English & Spanish. Your brand will shine best in our backyard.'
  }];
  return <section className="py-16 bg-[#F4E8D0]/30" data-id="element-298">
      <div className="container mx-auto px-4 md:px-6" data-id="element-299">
        <div className="max-w-3xl mx-auto text-center mb-12" data-id="element-300">
          <h2 className="text-3xl md:text-4xl font-bold text-[#374047] mb-4" data-id="element-301">
            Why Choose <span className="text-[#0099A1]" data-id="element-302">DestaMeet</span>
          </h2>
          <p className="text-lg text-[#374047]/80" data-id="element-303">
            The Premier Destination Management Company for transformative
            corporate experiences in Cancun & Riviera Maya.
          </p>
        </div>
        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6" data-id="element-304">
          {reasons.map((reason, index) => <Card key={index} className="h-full" data-id="element-305">
              <CardHeader className="flex flex-col items-center text-center" data-id="element-306">
                {reason.icon}
                <h3 className="text-xl font-semibold text-[#374047] mt-4" data-id="element-307">
                  {reason.title}
                </h3>
              </CardHeader>
              <CardBody className="text-center" data-id="element-308">
                <p className="text-[#374047]/80" data-id="element-309">{reason.description}</p>
              </CardBody>
            </Card>)}
        </div>
      </div>
    </section>;
}